/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { format, parse } from "date-fns";
import { Controller, useForm } from "react-hook-form";
import Select, { GroupBase, OptionsOrGroups } from "react-select";

import StatsReports from "../statsReports";

import useFetch from "src/hooks/useFetch";
import { AuthContext } from "../../../context/authContext";

import { APIEndpoints } from "src/types/apiTypes";
import { AccountManagerAPIProps, ProductRequestProps, StatisticsPropsType, StatisticsSearchProps } from "./types";




const CaseFilter: FC<StatisticsPropsType> = ({
  updateQueryParams,
  defaultQueryParams,
}): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [userListing, updateUserListing] = useState<AccountManagerAPIProps>([]);
  const { userData } = useContext(AuthContext);

  const { control, handleSubmit, getValues, setValue, watch } = useForm<StatisticsSearchProps>({
    mode: "all",
    defaultValues: defaultQueryParams,
  });

  const start_date = watch("start_date")
  const end_date = watch("end_date")

  const periodData = [
    { value: "day", label: "Group by Day" },
    { value: "week", label: "Group by Week" },
    { value: "month", label: "Group by Month" },
    { value: "quarter", label: "Group by Quarter" },
  ];

  const CompareFilterData = [
    { value: "p-1", label: "Compare With Previous Period" },
    { value: "y-1", label: "Compare With Previous Year" },

  ];


  /**
  * @GetProductListing API to call GetProductListing
  */
  const { data: productData, error: productError } = useFetch<ProductRequestProps[]>(APIEndpoints.GET_PRODUCTS,{},{},false);





  const { data: userListingData, mutate: getUserListing } =
    useFetch<AccountManagerAPIProps>(APIEndpoints.GET_USER_FOR_ACCOUNT_MANAGER, {}, {}, false);

  useEffect(() => {
    if (userListingData) {
      if (userData && userData.ref_type === "rep") {
        const data = userListingData.find((user) => user.id === userData?.id);
        if (!data)
          updateUserListing([...userListingData, { id: userData?.id || 0, fullname: userData?.name || "" }])
        else
          updateUserListing(userListingData)

        setValue("user_id", userData ? userData.id.toString() : "")
      } else {
        updateUserListing(userListingData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userListingData]);

  useEffect(() => {
    if (productData || productError) {
      if (userData && userData.ref_type !== "rep")
        getUserListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData, productError]);



  const searchForStats = (values: StatisticsSearchProps) => {
    const updatedValues = {
      ...values,
      period: values.period
        // ? typeof values.period === "string"
          // ? values.period
          && (values.period as unknown as { value: string; label: string }).value
        //: ""
        ,
      soc_value:
        values.soc_value
        //?(typeof values.soc_value === "string"
          //? values.soc_value
          && (values.soc_value as unknown as { value: string; name: string; }).value
          //: ""
          ,
      drug_id:
        values.drug_id
       // ?(typeof values.drug_id === "string"
          //? values.drug_id
          && (values.drug_id as unknown as { value: string; name: string; }).value
         // : ""
          ,
      filter_type: values.filter_type
       // ? typeof values.filter === "string"
          //? values.filter
          && (values.filter_type as unknown as { value: string; label: string }).value
        //: ""
        ,
      user_id:
        values.user_id
        //?(typeof values.user_id === "string"
          //? values.user_id
          && (values.user_id as unknown as { value: string; name: string; }).value
         // : ""
          ,
    };

    updateQueryParams(updatedValues, false);
  };



  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="card mt-4">
        <div className="card-header">
          <h4 className="m-0 ">Statistics</h4>
        </div>
        <div className="card-body pt-3">
          <div className="row g-3 statistics-filter mb-3 text-nowrap">
            <div className="col-12 col-md-2" style={{ minWidth: '260px' }}>
              <Controller
                name="start_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <div className="row">
                    <label htmlFor="start_date" className="form-label col-lg-4 col-md-4 col-12 pe-0">Start Date</label>
                    <div className="col-lg-8 col-md-8 col-12">
                      <div className="position-relative">
                        <DatePicker
                          id="start_date"
                          selected={field.value ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(val) => val ? field.onChange(format(val, "yyyy-MM-dd")) : null}
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          customInput={
                            <ReactInputMask mask="99/99/9999">
                              {(inputProps: {}) => <input {...inputProps} />}
                            </ReactInputMask>
                          }
                          maxDate={end_date ? new Date(end_date) : undefined}
                        />
                        <i
                          className="bi bi-calendar position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col-12 col-md-2" style={{ minWidth: '260px' }}>
              <Controller
                name="end_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <div className="row">
                    <label htmlFor="end_date" className="form-label col-lg-4 col-md-4 col-12 pe-0">End Date</label>
                    <div className="col-lg-8 col-md-8 col-12">
                      <div className="position-relative">
                        <DatePicker
                          id="end_date"
                          selected={field.value ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(val) => val ? field.onChange(format(val, "yyyy-MM-dd")) : null}
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          customInput={
                            <ReactInputMask mask="99/99/9999">
                              {(inputProps: {}) => <input {...inputProps} />}
                            </ReactInputMask>
                          }
                          minDate={start_date ? new Date(start_date) : undefined}
                        />
                        <i
                          className="bi bi-calendar position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col-12 col-md-3">
              <Controller
                name="period"
                control={control}
                render={( { field } ) => (
                  <Select
                    isClearable={true}
                    options={(periodData && periodData.length > 0 ?
                      periodData.map( ( item ) => ( {
                        value: item.value,
                        label: item.label
                      }))
                      : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="time"
                    {...field}
                    placeholder={'Group by Day'}
                  />
                )}
              />
            </div>
            <div className="col-12 col-md-3">
              <Controller
                name="filter_type"
                control={control}
                render={({ field }) => (
                  <Select
                    isClearable={true}
                    options={( CompareFilterData && CompareFilterData.length > 0 ?
                      CompareFilterData.map((item) => ({
                        value: item.value,
                        label: item.label
                      }))
                      : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="filter"
                    {...field}
                    placeholder={'Compare With ...'}
                  />
                )}
              />
            </div>
            <div className="col ms-auto">
              <button type="submit" className="btn btn-primary float-end"><i
                className="bi bi-arrow-clockwise"></i> Refresh
              </button>
            </div>
          </div>
          <StatsReports getValues={getValues} />
        </div>
      </div>
    </form>
  );
};

export default CaseFilter;
